import type { ComponentContentSchema } from '@vibesites/runtime';
import { EditableToken } from '@vibesites/runtime/react';
import { useCtaSheenStyles } from '../hooks/useCtaSheenStyles';

// Special offers are not used on Price Brothers sites at this time. This
// override keeps the inherited no-op banner, and installs primary-colored
// filled CTA sheen styles site-wide (this slot is first on nearly every page).
export function SpecialOfferBanner() {
  useCtaSheenStyles();

  return (
    <EditableToken
      path="specialofferbanner.title_display"
      defaultValue=""
      as="span"
      className="hidden"
      style={{ display: 'none' }}
    >
      {''}
    </EditableToken>
  );
}

export const contentSchema: ComponentContentSchema = {
  slot: 'SpecialOfferBanner',
  displayName: 'Special Offer Banner',
  tokens: {
    'specialofferbanner.title_display': {
      label: 'Offer Title',
      type: 'text',
      defaultValue: '',
    },
  },
};

(SpecialOfferBanner as unknown as { contentSchema: ComponentContentSchema }).contentSchema = contentSchema;

export default SpecialOfferBanner;
